import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../Helper/proccessErrorMessage";
import { API_INVESTMENT_TIMELINE } from "../../../config/api";

export const createTimeline = createAsyncThunk(
  "timeline/create",
  async ({ payload, cb, setSubmitting }, { rejectWithValue }) => {
    try {
      const { data } = await Client({
        method: "POST",
        path: API_INVESTMENT_TIMELINE,
        data: payload,
      });
      toast.success("Timeline created successfully");

      setSubmitting(false);
      cb();
      return data?.data;
    } catch (error) {
      const msg = proccessErrorMessage(error);
      toast.error(msg);
      setSubmitting(false);
      return rejectWithValue(error.message);
    }
  }
);
